import './index.css'

import { ThemeProvider } from '@arthur/ui'
import { DATE_LANGUAGE, DATE_LOCALE_TEXT } from '@common/constants/global.constants'
import { DateLanguage } from '@common/enums/global.enums'
import muiTheme from '@config/theme/mui'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { AuthProvider } from '@services/contexts/AuthContext'
import { LanguageProvider } from '@services/contexts/LanguageContext'
import { SnackbarProvider } from '@services/contexts/SnackbarContext'
import { QueryClient } from '@tanstack/query-core'
import { QueryClientProvider } from '@tanstack/react-query'
import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

const browserLanguage = navigator.language.split('-')[0]
const dateLanguage = Object.values(DateLanguage).find((language) => language.startsWith(`${browserLanguage}-`)) ?? DateLanguage.US
const adapterLocale = DATE_LANGUAGE[dateLanguage]
const localeText = DATE_LOCALE_TEXT[dateLanguage].components.MuiLocalizationProvider.defaultProps.localeText

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } })}>
				<AuthProvider>
					<LanguageProvider>
						<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale} localeText={localeText}>
							<MuiThemeProvider theme={muiTheme}>
								<ThemeProvider>
									<SnackbarProvider>
										<App />
									</SnackbarProvider>
								</ThemeProvider>
							</MuiThemeProvider>
						</LocalizationProvider>
					</LanguageProvider>
				</AuthProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</StrictMode>
)
